import styled, { css } from "styled-components";

export const Container = styled.div`
  background-color: var(--hv-surface-widget);
  width: 284px;
  height: 100%;
  border-radius: 12px;
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
  position: relative;
  padding-bottom: 16px;
`;

export const Title = styled.h1`
  font-size: 18px;
  font-weight: 600;
  color: var(--hv-text-normal-primary);
  padding: 20px 20px 12px 20px;
  line-height: var(--hv-lineheight-body-sm);
`;

export const FilterWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 20px 16px 20px;
`;

export const FilterName = styled.h2`
  font-size: 14px;
  font-weight: 400;
  color: var(--hv-icon-normal-secondary);
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: var(--hv-border-default);
`;

export const BottomWrap = styled.div`
  margin-top: auto;
  width: 100%;
  padding: 0 20px;

  /* this part should be replaced by HVButton props - fullWidth.
  but not working now, so please change this later */
  & > button {
    width: 100%;
  }
`;

export const InputTitle = styled.p`
  font-size: 14px;
  font-weight: 400;
  color: var(--hv-text-normal-primary);
`;

export const DropDownList = styled.ul`
  position: absolute;
  top: 28px;
  left: 0px;
  z-index: 1;

  background-color: var(--hv-surface-popup);
  box-shadow: var(--hv-shadow-2);
  border: 1px solid var(--hv-border-default);
  border-radius: 4px;

  padding: 4px;

  > li {
    color: var(--hv-text-normal-primary);
    height: 32px;
    width: 100px;
    display: flex;
    align-items: center;
    justify-content: left;
    padding: 0 12px;
    font-size: 14px;
    font-weight: 400;

    :hover {
      background-color: var(--hv-interaction-hover);
    }
  }
`;

export const SaveButton = styled.button<{ disabled?: boolean }>`
  border-radius: var(--hv-radius-xs);
  height: 24px;
  background-color: var(--hv-button-primary-default);
  color: var(--hv-text-on-brand-primary);
  display: inline-flex;
  align-items: center;
  position: relative;

  :active {
    background-color: var(--hv-button-primary-press);
  }

  :hover {
    background-color: var(--hv-button-primary-hover);
  }

  > span {
    font-size: var(--hv-fontsize-body-xs);
    padding: 0px 8px;
  }

  > button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 100%;
    box-sizing: border-box;
    border-left: 1px solid #ffffff36;
    border-radius: 0px;
    padding: 0 4px;
    box-sizing: border-box;
  }

  ${({ disabled }) =>
    disabled &&
    css`
      cursor: not-allowed;
      background-color: var(--hv-button-primary-disabled) !important;
      color: var(--hv-text-on-brand-disabled) !important;
    `};
`;

export const ObjectTypeButton = styled.button<{
  selected?: boolean;
  disabled?: boolean;
}>`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  justify-content: center;
  color: var(--hv-text-normal-secondary);
  font-size: var(---hv-fontsize-body-xs);
  border: 1px solid var(--hv-border-default);
  font-size: var(--hv-fontsize-body-xs);

  ${({ selected }) =>
    selected &&
    css`
      //[TODO]
      // Color/Dark/Brand is not supported is HVTheme
      // will be fixed in the future
      color: #f37321; // Color/Dark/Brand/B 0
      background-color: #f3732114; // Color/Dark/Brand/B 8
      border: 1.5px solid #f37321;
      font-weight: var(--hv-font-weight-bold);
      svg {
        stroke: #f37321;
        path {
          stroke-width: 2;
        }
      }
    `};

  ${({ disabled }) =>
    disabled &&
    css`
      background-color: var(--hv-interaction-disabled);
      color: var(--hv-text-normal-disabled);
      svg {
        stroke: var(--hv-icon-normal-disabled);
      }
    `};
  &:hover {
    background-color: var(--hv-interaction-hover);
  }
  &:active {
    background-color: var(--hv-interaction-press);
  }
`;

export const ObjectTypeWrap = styled.div`
  display: flex;
  gap: 8px;

  > ${ObjectTypeButton} {
    flex: 1;
    height: 80px;
  }
`;

export const LayerWrap = styled.div`
  position: absolute;
  z-index: 10;
  top: -120px;
  left: 284px;

  > div {
    top: 36px;
    left: 0px;
  }
`;

export const IconTextWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: left;
  gap: 4px;
`;

export const MenuButton = styled.button<{
  disabled?: boolean;
  isActive?: boolean;
}>`
  height: 40px;
  width: 100%;
  box-sizing: border-box;
  font-size: 14px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: left;
  white-space: nowrap;
  gap: 8px;
  ${({ disabled }) =>
    disabled
      ? "background-color: var(--hv-input-foreground-disabled); color: var(--hv-text-normal-disabled);"
      : "background-color: transparent; color:var(--hv-text-normal-secondary); border: 1px solid var(--hv-border-default);"}
  svg {
    path {
      ${({ disabled }) => disabled && "stroke: var(--hv-icon-normal-disabled);"}
    }
  }
  ${({ disabled }) =>
    !disabled &&
    css`
      &:hover {
        color: var(--hv-text-normal-primary);
        background-color: var(--hv-interaction-hover);
      }

      &:active {
        color: var(--hv-text-normal-primary);
        background-color: var(--hv-interaction-press);
      }
    `}
`;
